import React, { PureComponent } from 'react';
import HeatMap from "react-heatmap-grid";


const xLabels = ["A", "B", "C", "D", "E", "F", "G"];

const yLabels = ["A", "B", "C", "D", "E", "F", "G"];

// const data = new Array(yLabels.length)
//     .fill(0)
//     .map(() =>
//         new Array(xLabels.length).fill(0).map(() => Math.floor(Math.random() * 100))
//     );
//
//     console.log('Data: ')
//     console.log(data)
const data = [[100,-30,-65,25,67,32,-43],
              [-30,100,30,-53,35,58,-33],
              [-65,30,100,-9,-24,43,-75],
              [25,-53,-9,100,-1,78,54],
              [67,35,-24,-1,100,35,-21],
              [32,58,43,78,35,100,48],
              [-43,-33,-75,54,-21,48,100]]

export default class CorrelationRiskChart extends PureComponent {

    render() {
        return (
            <div style={{ fontSize: "13px" }} style={{margin: "auto"}}>
                <HeatMap
                    xLabels={xLabels}
                    yLabels={yLabels}
                    xLabelsLocation={"bottom"}
                    xLabelWidth={60}
                    data={data}
                    squares
                    cellStyle={(background, value, min, max, data, x, y) => ({
                        background: `rgb(169, 169, 169, ${1 - (max - value) / (max - min)})`,
                        fontSize: "11.5px",
                        color: "#000"
                    })}
                    cellRender={value => value && `${value}%`}
                />
            </div>
        );
    }
}